












import { snakeCase } from 'lodash'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import BaseButtonBuilder from '../Buttons'
import ButtonsManager from '../logic/ButtonsManager'
import { ButtonBuildersGroups } from '../logic/types'

@Component({
  data() {
    return {
      snakeCase
    }
  }
})
export default class ButtonsListCard extends Vue {
  @Prop() buttonsManager!: ButtonsManager

  @Prop() item!: BaseButtonBuilder | ButtonBuildersGroups

}
